import React, { useEffect } from "react";
import { useTranslation } from "../context/LanguageContext";
import { Helmet } from "react-helmet-async";
import UpdatingMessage from "../components/ui/UpdatingMessage";

const Contact = () => {
  const { locale, translate } = useTranslation();

  useEffect(() => {
    if (locale !== "kr") {
      window.location.replace("https://www.facebook.com/profile.php?id=61567462526332");
    }
  }, [locale]);

  return (
    <>
      <Helmet>
        <title>{translate("meta.title_contact")}</title>
        <meta name="description" content={translate("meta.description")} />
      </Helmet>
      <UpdatingMessage />
    </>
  );
};

export default Contact;


